import { render } from "./TaskPane.vue?vue&type=template&id=b37c07b4&scoped=true"
import script from "./TaskPane.vue?vue&type=script&lang=js"
export * from "./TaskPane.vue?vue&type=script&lang=js"

import "./TaskPane.vue?vue&type=style&index=0&id=b37c07b4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b37c07b4"]])

export default __exports__